import React from 'react';

import { PageInfoHeader } from '../../PageInfoHeader/PageInfoHeader';

import './Help.scss';

const FAQ_URLS = [
  {
    url: 'https://elligodirect.atlassian.net/servicedesk/customer/portal/8/group/52/create/229',
    text: 'Need to add a new IntElligo User?'
  },
  {
    url: 'https://elligodirect.atlassian.net/servicedesk/customer/portal/8/group/52/create/230',
    text: 'Issues with Patient Stipends?'
  },
  {
    url: 'https://elligodirect.atlassian.net/servicedesk/customer/portal/8/group/52/create/231',
    text: 'Issue with Patient Status?'
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligo-Data.pdf',
    text: 'IntElligo Data Compliance Assessment (FAQs)',
    download: true
  }
];

const USER_GUIDES = [
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/CRA-Review.pdf',
    text: 'CRA Review Guide',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/ICF-Workflow.pdf',
    text: 'ICF Workflow',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/PI-Worklist.pdf',
    text: 'Investigator Worklist Guide',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Calendar-Navigation.pdf',
    text: 'Using the Calendar',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Dashboards.pdf',
    text: 'Using the Dashboards',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Prescreen-Worklist.pdf',
    text: 'Using the Pre-Screening Worklist',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Scheduling-Worklist.pdf',
    text: 'Using the Scheduling Worklist',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/SM-Worklist.pdf',
    text: 'Using the Study Manager Worklist',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Task-Management.pdf',
    text: 'Using the Task Worklist',
    download: true
  }
];

const HOWTO_GUIDES = [
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Fixed-Items.pdf',
    text: 'Adding an Expense Fixed',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Encounter-Cancel.pdf',
    text: 'Canceling an Encounter',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Encounter-Close.pdf',
    text: 'Closing an Encounter',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Unscheduled-Events.pdf',
    text: 'Handling Unscheduled Visits',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Managing-Adverse-Events.pdf',
    text: 'Managing Adverse Events',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Navigating-Patient-Studies.pdf',
    text: 'Navigating Patient Studies',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Preview-Study-Source-setup.pdf',
    text: 'Previewing IntElligo Protocol Setup',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/Certified-eSource-Copies.pdf',
    text: 'Using Certified eSource Copy Feature',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/When_to_NP.pdf',
    text: 'Using the "Not Perform" Feature',
    download: true
  }
];

const VIDEO_GUIDES = [
  {
    title: 'Informed Consent and Audit Report',
    src: 'https://intelligo-static-assets.s3.amazonaws.com/help/video/ICF_and_Audit_Report.mp4'
  },
  {
    title: 'Granular Permissions',
    src: 'https://intelligo-static-assets.s3.amazonaws.com/help/video/Granular_Permissions.mp4'
  },
  {
    title: 'CRA Review Guide',
    src: 'https://intelligo-static-assets.s3.amazonaws.com/help/video/CRAReview.mp4'
  },
  {
    title: 'Distributing Patient Stipends',
    src: 'https://intelligo-static-assets.s3.amazonaws.com/help/video/ElligoPatientStipends.mp4'
  }
];

const RELEASE_NOTES = [
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSevenTwo.pdf',
    text: 'Release Notes v7.2',
    download: true,
    current: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSevenOne.pdf',
    text: 'Release Notes v7.1',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSevenO.pdf',
    text: 'Release Notes v7.0',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixThirteen.pdf',
    text: 'Release Notes v6.13',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixTwelve.pdf',
    text: 'Release Notes v6.12',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixEleven.pdf',
    text: 'Release Notes v6.11',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixTen.pdf',
    text: 'Release Notes v6.10',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixNine.pdf',
    text: 'Release Notes v6.9',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixEight.pdf',
    text: 'Release Notes v6.8',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixSeven.pdf',
    text: 'Release Notes v6.7',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixSix.pdf',
    text: 'Release Notes v6.6',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixFive.pdf',
    text: 'Release Notes v6.5',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixFour.pdf',
    text: 'Release Notes v6.4',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixThree.pdf',
    text: 'Release Notes v6.3',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixTwo.pdf',
    text: 'Release Notes v6.2',
    download: true
  },
  {
    url: 'https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoSixOne.pdf',
    text: 'Release Notes v6.1',
    download: true
  }
];

const LinkColumn = ({ title, links }) => (
  <div className="column3">
    <h5 className="c-p">{title}</h5>
    <br />
    <ul>
      {links.map((link, idx) => (
        <li key={idx}>
          <a href={link.url} target="_blank" rel="noopener noreferrer" {...(link.download ? { download: true } : {})}>
            {link.text}
          </a>
        </li>
      ))}
    </ul>
    <br />
  </div>
);

const VideoColumn = ({ videos }) => (
  <div className="row">
    {videos.map((video, idx) => (
      <div className="column2" key={video.title}>
        <h5 className="c-p">{video.title}</h5>
        <br />
        <video className="video" muted controls={['PlayPause', 'Seek', 'Time', 'Volume', 'Fullscreen']}>
          <source src={video.src} type="video/mp4" />
          Your browser does not support playing this video. Please use Chrome.
        </video>
      </div>
    ))}
  </div>
);

const Help = () => {
  return (
    <div className="eds-help-page">
      <PageInfoHeader />
      <section className="border" id="helpContent">
        <br />
        <div>
          <div className="row">
            <LinkColumn title="FAQs:" links={FAQ_URLS} />
            <LinkColumn title="USER GUIDES:" links={USER_GUIDES} />
            <LinkColumn title="HOW-TO GUIDES:" links={HOWTO_GUIDES} />
          </div>
        </div>
        <br />
      </section>
      <section className="border" id="helpContent">
        <br />
        <div className="bottomCenter supportText">
          Still can’t find what you are looking for? Submit a{' '}
          <a
            href="https://elligodirect.atlassian.net/servicedesk/customer/portal/8"
            target="_blank"
            rel="noopener noreferrer"
          >
            Support Request
          </a>{' '}
          for our IntElligo team.
        </div>
        <br />
      </section>
      <section className="border" id="helpContent">
        <br />
        <VideoColumn videos={VIDEO_GUIDES.slice(0, 2)} />
        <br />
        <VideoColumn videos={VIDEO_GUIDES.slice(2)} />
        <br />
      </section>
      <section className="border" id="helpContent">
        <br />
        <div>
          <div className="row">
            <div className="column4">
              <h5 className="c-p">Release Notes</h5>
              <ul>
                <br />
                {RELEASE_NOTES.slice(0, 4).map((note, idx) => (
                  <li key={idx}>
                    <a
                      href={note.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      {...(note.download ? { download: true } : {})}
                    >
                      {note.text}
                    </a>
                    {note.current ? ' - (current)' : ''}
                  </li>
                ))}
              </ul>
            </div>
            <div className="column4">
              <br />
              <br />
              <ul>
                {RELEASE_NOTES.slice(4, 8).map((note, idx) => (
                  <li key={idx}>
                    <a
                      href={note.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      {...(note.download ? { download: true } : {})}
                    >
                      {note.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="column4">
              <br />
              <br />
              <ul>
                {RELEASE_NOTES.slice(8, 12).map((note, idx) => (
                  <li key={idx}>
                    <a
                      href={note.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      {...(note.download ? { download: true } : {})}
                    >
                      {note.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="column4">
              <br />
              <br />
              <ul>
                {RELEASE_NOTES.slice(12).map((note, idx) => (
                  <li key={idx}>
                    <a
                      href={note.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      {...(note.download ? { download: true } : {})}
                    >
                      {note.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <br />
      </section>
      <section className="border" id="helpContent">
        <div className="bottomCenter termsOfUse">
          <a
            className="c-p"
            href="https://intelligo-static-assets.s3.amazonaws.com/help/files/IntElligoTermsOfUse.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download
          >
            Terms of Use
          </a>
        </div>
      </section>
    </div>
  );
};

export default Help;
